// UUID generation removed — cart_id is now issued by the backend

export interface VehicleData {
  brandId: string | null;
  brandName: string | null;
  brandLogo: string | null;
  colorId: string | null;
  colorName: string | null;
  colorCode: string | null;
  plateNumber: string | null;
}

export interface AddressData {
  latitude: number;
  longitude: number;
  streetName: string | null;
  buildingNumber: string | null;
  floorNumber: string | null;
  apartmentNumber: string | null;
  geocodeAddress: string | null;
  details: string | null;
}

export interface OrderSession {
  cartId: string;
  restaurantId: string | null;
  order_type: "pickup" | "delivery" | "dine_in";
  branchId: string | null;
  branchAsapAllowed: number;
  branchScheduleAllowed: number;
  branchName: string | null;
  paymentMethodId: string | null;
  paymentMyfatoorah: boolean;
  paymentMyfatoorahMethod: string | null;
  paymentTap: boolean;
  paymentTapMethod: string | null;
  paymentMethodObject: Record<string, unknown>;
  paymentSession: string | null;
  paymentBrand: string | null;
  usePoints: boolean;
  useWallet: boolean;
  vehicle: VehicleData;
  deliveryTime: string | null;
  scheduledDay: string | null;
  scheduledPeriod: string | null;
  userAreaName: string | null;
  isOpen: boolean;
  isBusy: boolean;
  branchStatusReason: string | null;
  distance_km?: number | 0 ;
}

export interface Coordinates {
  latitude: number | null;
  longitude: number | null;
}

export interface CustomerSession {
  isGuest: boolean;
  token: string | null;
  data: Record<string, unknown>;
  lastCoordinates: Coordinates;
  geolocationCoordinates: Coordinates;
  selectedAddress: AddressData;
  addresses: AddressData[];
  vehicles: VehicleData[];
}

export interface AppSession {
  order: OrderSession;
  customer: CustomerSession;
  cartItemsLength: number;
}

const MAX_ADDRESSES = 10;
const MAX_VEHICLES = 5;

export { MAX_ADDRESSES, MAX_VEHICLES };

export function createDefaultSession(): AppSession {
  return {
    order: {
      cartId: "",
      restaurantId: null,
      order_type: "pickup",
      branchId: null,
      branchAsapAllowed: 1,
      branchScheduleAllowed: 0,
      branchName: null,
      paymentMethodId: null,
      paymentMyfatoorah: false,
      paymentMyfatoorahMethod: null,
      paymentTap: false,
      paymentTapMethod: null,
      paymentMethodObject: {},
      paymentSession: null,
      paymentBrand: null,
      usePoints: false,
      useWallet: false,
      vehicle: {
        brandId: null,
        brandName: null,
        brandLogo: null,
        colorId: null,
        colorName: null,
        colorCode: null,
        plateNumber: null,
      },
      deliveryTime: null,
      scheduledDay: null,
      scheduledPeriod: null,
      userAreaName: null,
      isOpen: true,
      isBusy: false,
      branchStatusReason: null,
    },
    customer: {
      isGuest: true,
      token: null,
      data: {},
      lastCoordinates: { latitude: null, longitude: null },
      geolocationCoordinates: { latitude: null, longitude: null },
      selectedAddress: {
        latitude: 0,
        longitude: 0,
        streetName: null,
        buildingNumber: null,
        floorNumber: null,
        apartmentNumber: null,
        geocodeAddress: null,
        details: null,
      },
      addresses: [],
      vehicles: [],
    },
    cartItemsLength: 0,
  };
}
